(function () {
    var modalBackdropEl = null;
  
    function ensureModalBackdrop() {
      if (modalBackdropEl) return modalBackdropEl;
      modalBackdropEl = document.createElement('div');
      modalBackdropEl.className = 'tp-drill-modal__backdrop';
      modalBackdropEl.hidden = true;
      modalBackdropEl.setAttribute('aria-hidden', 'true');
      modalBackdropEl.addEventListener('click', function () {
        var dlg = modalBackdropEl._tpActiveDialog;
        if (dlg) closeTpDrillDialog(dlg);
      });
      document.body.appendChild(modalBackdropEl);
      return modalBackdropEl;
    }
  
    function portalDrillDialog(dlg) {
      if (dlg.dataset.tpPortaled === '1') return;
      document.body.appendChild(dlg);
      dlg.dataset.tpPortaled = '1';
    }
  
    function openTpDrillDialog(dlg) {
      portalDrillDialog(dlg);
      var backdrop = ensureModalBackdrop();
      backdrop.hidden = false;
      backdrop.setAttribute('aria-hidden', 'false');
      backdrop._tpActiveDialog = dlg;
      dlg.removeAttribute('hidden');
      dlg.setAttribute('open', '');
      document.body.classList.add('tp-drill-modal-body-lock');
      return true;
    }
  
    function closeTpDrillDialog(dlg) {
      var mount = dlg.querySelector('[data-tp-drill-modal-mount]');
      dlg.removeAttribute('open');
      dlg.setAttribute('hidden', '');
      document.body.classList.remove('tp-drill-modal-body-lock');
      if (modalBackdropEl) {
        modalBackdropEl.hidden = true;
        modalBackdropEl.setAttribute('aria-hidden', 'true');
        modalBackdropEl._tpActiveDialog = null;
      }
      if (mount) {
        pauseDrillMount(mount);
        mount.innerHTML = '';
      }
      dlg.removeAttribute('aria-labelledby');
    }
  
    function primeDrillModalVideo(dlg) {
      var video = dlg.querySelector('video.tp-drill-modal__video-el');
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  
    function hasTrainingGate() {
      return !!document.querySelector(
        '[data-training-program] .training-prog__gate'
      );
    }
  
    function isHeaderSignedIn() {
      return !!document.querySelector('.header__account--signed-in');
    }
  
    function verifyLoggedIn() {
      return fetch('/account', {
        credentials: 'same-origin',
        redirect: 'manual',
        cache: 'no-store',
      }).then(function (res) {
        return res.status === 200;
      }).catch(function () {
        return false;
      });
    }
  
    function reconcileTrainingAccess() {
      document.querySelectorAll('[data-training-program]').forEach(function (section) {
        if (section.getAttribute('data-tp-customer-logged-in') === 'true') return;
        if (!section.querySelector('.training-prog__gate')) return;
  
        function reloadIfLoggedIn(isLoggedIn) {
          if (!isLoggedIn) return;
          var url = new URL(window.location.href);
          if (url.searchParams.has('tp_auth_refresh')) return;
          url.searchParams.set('tp_auth_refresh', '1');
          window.location.replace(url.toString());
        }
  
        if (isHeaderSignedIn()) {
          reloadIfLoggedIn(true);
          return;
        }
  
        verifyLoggedIn().then(reloadIfLoggedIn);
      });
    }
  
    function weekCount(section) {
      return section.querySelectorAll('[data-tp-week-tab]').length;
    }
  
    function activeWeekIndex(section) {
      var tab =
        section.querySelector('[data-tp-week-tab][aria-selected="true"]') ||
        section.querySelector('[data-tp-week-tab].training-prog__tab--active');
      if (!tab) return 1;
      return parseInt(tab.getAttribute('data-tp-week-index'), 10) || 1;
    }
  
    function syncMobileWeekChrome(section, weekIndexStr) {
      var titleEl = section.querySelector('[data-tp-current-week-title]');
      var sel = section.querySelector('[data-tp-week-select]');
      var tab = section.querySelector(
        '[data-tp-week-tab][data-tp-week-index="' + weekIndexStr + '"]'
      );
      if (tab && titleEl) {
        var lab = tab.querySelector('.training-prog__tab-label');
        titleEl.innerHTML = lab ? lab.innerHTML : '';
      }
      if (sel && weekIndexStr) sel.value = weekIndexStr;
    }
  
    function activatePart(weekPanel, partStr) {
      if (!weekPanel) return;
      weekPanel.querySelectorAll('[data-tp-part-tab]').forEach(function (btn) {
        var active = btn.getAttribute('data-tp-part') === partStr;
        btn.classList.toggle('training-prog__inner-tab--active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });
  
      weekPanel.querySelectorAll('[data-tp-part-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-tp-part-panel') === partStr;
        panel.classList.toggle('training-prog__part-panel--active', active);
        panel.hidden = !active;
      });
    }
  
    function drillDoneStorageKey(storageKey) {
      return 'pv.tpDrillDone.' + storageKey;
    }
  
    function hydrateDrillDoneCheckboxes(mount) {
      if (!mount) return;
      mount.querySelectorAll('[data-tp-drill-done]').forEach(function (cb) {
        var key = cb.getAttribute('data-tp-drill-storage-key');
        if (!key) return;
        try {
          cb.checked = localStorage.getItem(drillDoneStorageKey(key)) === '1';
        } catch (_) {
          cb.checked = false;
        }
      });
    }
  
    function scrollDrillModalToTop(dlg) {
      var grid = dlg.querySelector('.tp-drill-modal__grid');
      if (grid) grid.scrollTop = 0;
    }
  
    function mountDrillTemplate(dlg, tplId) {
      var tpl = tplId ? document.getElementById(tplId) : null;
      var mount = dlg.querySelector('[data-tp-drill-modal-mount]');
      if (!mount || !tpl || !tpl.content) return false;
  
      pauseDrillMount(mount);
      mount.innerHTML = '';
      mount.appendChild(document.importNode(tpl.content, true));
  
      var titleEl = mount.querySelector('.tp-drill-modal__title');
      if (titleEl && titleEl.id) dlg.setAttribute('aria-labelledby', titleEl.id);
      else dlg.removeAttribute('aria-labelledby');
  
      hydrateDrillDoneCheckboxes(mount);
      scrollDrillModalToTop(dlg);
      return true;
    }
  
    function pauseDrillMount(mount) {
      if (!mount) return;
      mount.querySelectorAll('video').forEach(function (v) {
        try {
          v.pause();
          v.currentTime = 0;
        } catch (_) {}
        v.removeAttribute('src');
        v.querySelectorAll('source').forEach(function (s) {
          s.removeAttribute('src');
        });
        try {
          v.load();
        } catch (_) {}
      });
      mount.querySelectorAll('iframe').forEach(function (f) {
        try {
          f.removeAttribute('src');
        } catch (_) {}
        f.src = '';
      });
    }
  
    function openTpDrillModal(btn) {
      var dialogId = btn.getAttribute('data-tp-drill-dialog-id');
      var card = btn.closest('.training-prog__inner-card');
      var dlg =
        (card && card.querySelector('[data-tp-drill-dialog]')) ||
        (dialogId ? document.getElementById(dialogId) : null);
      var tplId = btn.getAttribute('data-tp-drill-modal-template');
      if (!dlg || !tplId) return;
  
      if (!mountDrillTemplate(dlg, tplId)) return;
  
      if (!openTpDrillDialog(dlg)) return;
      primeDrillModalVideo(dlg);
  
      var focusEl = dlg.querySelector('[data-tp-drill-modal-close]');
      if (focusEl) focusEl.focus();
    }
  
    function wireTpDrillDialogs(section) {
      section.querySelectorAll('[data-tp-drill-dialog]').forEach(function (dlg) {
        if (dlg.dataset.tpDrillDialogWired === '1') return;
        dlg.dataset.tpDrillDialogWired = '1';
  
        dlg.addEventListener('change', function (e) {
          var t = e.target;
          if (
            !t ||
            typeof t.matches !== 'function' ||
            !t.matches('[data-tp-drill-done]') ||
            !dlg.contains(t)
          )
            return;
          var key = t.getAttribute('data-tp-drill-storage-key');
          if (!key) return;
          try {
            if (t.checked) localStorage.setItem(drillDoneStorageKey(key), '1');
            else localStorage.removeItem(drillDoneStorageKey(key));
          } catch (_) {}
        });
  
        dlg.addEventListener('click', function (e) {
          if (e.target === dlg) {
            closeTpDrillDialog(dlg);
            return;
          }
          if (e.target.closest('[data-tp-drill-modal-close]')) {
            closeTpDrillDialog(dlg);
            return;
          }
  
          var prevBtn = e.target.closest('[data-tp-drill-modal-prev]');
          if (prevBtn && dlg.contains(prevBtn) && !prevBtn.disabled) {
            e.preventDefault();
            var pt = prevBtn.getAttribute('data-tp-drill-modal-template');
            if (pt && mountDrillTemplate(dlg, pt)) {
              primeDrillModalVideo(dlg);
              var pClose = dlg.querySelector('[data-tp-drill-modal-close]');
              if (pClose) pClose.focus();
            }
            return;
          }
  
          var nextBtn = e.target.closest('[data-tp-drill-modal-next]');
          if (nextBtn && dlg.contains(nextBtn) && !nextBtn.disabled) {
            e.preventDefault();
            var nt = nextBtn.getAttribute('data-tp-drill-modal-template');
            if (nt && mountDrillTemplate(dlg, nt)) {
              primeDrillModalVideo(dlg);
              var nClose = dlg.querySelector('[data-tp-drill-modal-close]');
              if (nClose) nClose.focus();
            }
          }
        });
      });
    }
  
    function activateWeek(section, weekIndexStr) {
      section.querySelectorAll('[data-tp-week-tab]').forEach(function (btn) {
        var active = btn.getAttribute('data-tp-week-index') === weekIndexStr;
        btn.classList.toggle('training-prog__tab--active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });
  
      section.querySelectorAll('[data-tp-week-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-tp-week-panel') === weekIndexStr;
        panel.classList.toggle('training-prog__week-panel--active', active);
        panel.hidden = !active;
        if (!active) {
          panel.setAttribute('aria-hidden', 'true');
        } else {
          panel.removeAttribute('aria-hidden');
        }
      });
  
      syncMobileWeekChrome(section, weekIndexStr);
  
      var panel = section.querySelector(
        '[data-tp-week-panel].training-prog__week-panel--active'
      );
      if (panel) activatePart(panel, '1');
    }
  
    function initSection(section) {
      wireTpDrillDialogs(section);
  
      var weeks = section.querySelectorAll('[data-tp-week-tab]');
      var prevBtn = section.querySelector('[data-tp-week-prev]');
      var nextBtn = section.querySelector('[data-tp-week-next]');
      var weekSelect = section.querySelector('[data-tp-week-select]');
  
      if (prevBtn && weeks.length) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var n = weekCount(section);
          var idx = activeWeekIndex(section);
          var next = ((idx - 2 + n) % n) + 1;
          activateWeek(section, String(next));
        });
      }
  
      if (nextBtn && weeks.length) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var n = weekCount(section);
          var idx = activeWeekIndex(section);
          var next = (idx % n) + 1;
          activateWeek(section, String(next));
        });
      }
  
      if (weekSelect) {
        weekSelect.addEventListener('change', function () {
          if (!weekSelect.value) return;
          activateWeek(section, weekSelect.value);
        });
      }
  
      section.addEventListener('click', function (e) {
        var drillOpen = e.target.closest('[data-tp-drill-modal-open]');
        if (drillOpen && section.contains(drillOpen)) {
          e.preventDefault();
          openTpDrillModal(drillOpen);
          return;
        }
  
        var wBtn = e.target.closest('[data-tp-week-tab]');
        if (wBtn && section.contains(wBtn)) {
          e.preventDefault();
          var idx = wBtn.getAttribute('data-tp-week-index');
          activateWeek(section, idx);
          return;
        }
  
        var pBtn = e.target.closest('[data-tp-part-tab]');
        if (pBtn && section.contains(pBtn)) {
          e.preventDefault();
          var wp = pBtn.closest('[data-tp-week-panel]');
          activatePart(wp, pBtn.getAttribute('data-tp-part'));
        }
      });
  
      if (weeks.length) {
        weeks.forEach(function (btn, i) {
          btn.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            e.preventDefault();
            var delta = e.key === 'ArrowRight' ? 1 : -1;
            var next = (i + delta + weeks.length) % weeks.length;
            weeks[next].focus();
            weeks[next].click();
          });
        });
        activateWeek(section, '1');
        return;
      }
  
      var p1 = section.querySelector('[data-tp-week-panel="1"], [data-tp-week-panel]');
      if (p1)
        activateWeek(section, p1.getAttribute('data-tp-week-panel') || '1');
    }
  
    document.querySelectorAll('[data-training-program]').forEach(initSection);
  
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openDlg = document.querySelector('[data-tp-drill-dialog][open]');
      if (openDlg) closeTpDrillDialog(openDlg);
    });
  
    reconcileTrainingAccess();
  
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !hasTrainingGate()) return;
      reconcileTrainingAccess();
    });
  })();
  